<template>
  <div></div>
</template>

<script>
export default {
  name: 'PlansCell'
}
</script>

<style scoped></style>
